
class ConfiguratorStep {
    constructor(stepElement, configurator) {
      this.el = stepElement;
      this.configurator = configurator;
      this.products = [];
      this.stepName = this.el.dataset.stepName;
      this.stepProductId = this.el.dataset.stepProductId;
      this.price = parseFloat(this.el.dataset.stepPrice || "0");
      this.stepPrice = parseFloat(this.el.dataset.stepPrice || "0");
      this.exceptions = JSON.parse(this.el.dataset.exceptions || "{}");
      this.isOptional = this.el.dataset.isOptional === "true" ? true : false;
      this.isMultipleSelection = this.el.dataset.multipleSelection === "true";
      this.selectedProducts = [];
      this.topElement = this.el.querySelector(".configurator__step-top");

      this.showOnlyIfProductIsSelected = this.el.dataset.showOnlyIfProductIsSelected === "true";
      this.showOnlyIfProductIsSelectedIds = this.el.dataset.showOnlyIfProductIsSelectedIds?.split(',') || [];
      this.isShown;
      this.lowestPrice = this.price;

      this.init();
    }

    setLowestPrice(){
      this.products.forEach(product => {
        if(product.price < this.lowestPrice){
          this.lowestPrice = product.price;
        }
      });
    }

    open(){
      console.log(this.configurator.activeStep);
      this.configurator?.activeStep?.close();
      this.el.classList.add("configurator__step--active");
      this.configurator.activeStep = this;

      this.configurator.configuratorContentElement.scrollTo({
        top: this.el.offsetTop - 100,
        behavior: 'smooth'
      });
    }

    close(){
      this.el.classList.remove("configurator__step--active");
    }

    toggle(){
      this.el.classList.toggle("configurator__step--active");
    }

    show(){
      // method dedicated for show step only if product is selected
      if(this.isShown) return;

      this.isShown = true;
      this.el.classList.remove("configurator__step--hidden");
      if(!this.isOptional) this.selectProduct(this.products[0], false);
    }

    hide(){
      // method dedicated for show step only if product is selected
      if(!this.isShown) return;

      this.isShown = false;
      this.el.classList.add("configurator__step--hidden");
      this.selectProduct(null,true);
      this.selectedProducts = [];
    }
  
    init() {
     // add event listener to toggle step products list
      this.topElement.addEventListener("click", () => {
        if(this.el.classList.contains("configurator__step--active")){
          this.close();
        } else {
          this.open();
        }
      });
  
    // create array of StepProduct objects
      const productEls = this.el.querySelectorAll(".configurator__step-product");
      productEls.forEach(productEl => {
        const product = new StepProduct(productEl, this);
        this.products.push(product);
      });

      this.setLowestPrice();
      this.products.forEach(product => {
        product.setDifferenceBetweenLowestPrice();
      });

      if(!this.isOptional && !this.showOnlyIfProductIsSelected){
        const firstAvailableProduct = this.products.find(p => p.available);
        if(firstAvailableProduct) this.selectedProducts.push(firstAvailableProduct);

         // update price
        const additionalPrice = this.selectedProducts.reduce((acc, p) => acc + p.price, 0);
        // const delta = parseFloat(additionalPrice) - parseFloat(this.stepPrice);

        this.configurator.adjustPrice(additionalPrice);
        this.stepPrice = additionalPrice;


        // update step product id and step price
        this.stepProductId = firstAvailableProduct.id;
    
        //   update step title
        this.updateStepTitle(firstAvailableProduct.title);
    

        this.configurator.updateProductsVisibility();
      }


      this.updateProductsPrices();

      // update step title
      const stepTitle = this.selectedProducts.map(p => {
        // if(p.differenceBetweenLowestPrice > 0){
        //   const formattedPrice = Math.round(p.differenceBetweenLowestPrice / 100);
        //   return p.title + ' ' + "<strong>(+" + formattedPrice + ' ' + this.configurator.currencySymbol + ")</strong>";
        // }else{
        //   return p.title;
        // }
        return p.title;
      }).join(', ');
      this.updateStepTitle(stepTitle);

      if(this.showOnlyIfProductIsSelected){
        this.isShown = true;
        this.stepPrice = 0;
        this.stepProductId = null;
        this.hide();
      }
    }
  
    selectProduct(product, deactivate) {
      // if(!product.available) return;

      if(this.isMultipleSelection){
        const isProductAdded = this.selectedProducts.find(p => p.id === product?.id);
        
        if(isProductAdded){ 
          this.selectedProducts = this.selectedProducts.filter(p => p.id !== product?.id);
          product.deactivate();
        } else if (deactivate) {
          this.selectedProducts = []
          product?.deactivate();
        } else {
          this.selectedProducts.push(product);
          product.activate();
        }
      } else {
         // deactivate current active product
        const currentProduct = this.products.find(p => p.isActive());
        
        if(deactivate){
        currentProduct?.deactivate();
        this.selectedProducts = []
        } else if (currentProduct && currentProduct !== product) {
          currentProduct.deactivate();
          this.selectedProducts = this.selectedProducts.filter(p => p.id !== currentProduct.id);

          this.selectedProducts.push(product);
          product.activate();
        } else if(currentProduct && currentProduct === product && this.isOptional){
          currentProduct.deactivate();
          this.selectedProducts = this.selectedProducts.filter(p => p.id !== currentProduct.id);
        } else if(!currentProduct) {
          product.activate();
          this.selectedProducts.push(product);
        }
      }

      
      // update price
      const additionalPrice = this.selectedProducts.reduce((acc, p) => acc + p.price, 0);
      const delta = parseFloat(additionalPrice) - parseFloat(this.stepPrice);
      
      this.configurator.adjustPrice(delta);
      this.stepPrice = additionalPrice;


      // update step product id and step price
      this.stepProductId = product?.id;

      this.configurator.updateStepVisibility();
      this.configurator.updateProductsVisibility();

      // update step title
      const stepTitle = this.selectedProducts.map(p => {
        // if(p.differenceBetweenLowestPrice > 0){
        //   const formattedPrice = Math.round(p.differenceBetweenLowestPrice / 100);
        //   return p.title + ' ' + "<strong>(+" + formattedPrice + ' ' + this.configurator.currencySymbol + ")</strong>";
        // }else{
        //   return p.title;
        // }
        return p.title;
      }).join(', ');
      this.updateProductsPrices();
      this.updateStepTitle(stepTitle);


    }

    updateProductsPrices(){
      this.products.forEach(prod => {
        prod.setPrice();
      });
    }

    updateStepTitle(title){
        this.el.querySelector(".configurator__step-title-product").innerHTML = title;
    }

    hideProductAndSelectTheFirstAvailable(hiddenProduct){
        let isSelected = false;

        if(this.isOptional && hiddenProduct){
          // deselect product if it's optional 
          this.selectProduct(hiddenProduct)
          return;
        } 

        const firstAvailableProduct = this.products.find(product => !product.hidden);
        if(firstAvailableProduct){
            this.selectProduct(firstAvailableProduct);
            isSelected = true;
        }
    }
  }

  class StepProduct {
    constructor(productEl, step) {
      this.el = productEl;
      this.step = step;
      this.configurator = step.configurator;
  
      this.id = this.el.dataset.productId;
      this.title = this.el.dataset.productTitle;
      this.price = parseFloat(this.el.dataset.productPrice);
      this.variantId = this.el.dataset.variantId;
      this.hidden = false;
      this.available = this.el.dataset.productAvailable === "true";

      this.stepPrice = this.price;
      this.displayPrice = null;
      this.differenceBetweenLowestPrice = null;

      this.priceElement = this.el.querySelector('.price-item');
  
      this.el.addEventListener("click", () => {
        this.step.selectProduct(this);
      });
    }

    setDifferenceBetweenLowestPrice(){
      this.differenceBetweenLowestPrice = this.price - this.step.lowestPrice;
    }

    setPrice(){
      let newDisplayPrice = null;
      // console.log(this.price, this.step.lowestPrice);

      //   newDisplayPrice = Math.round((this.price - this.step.lowestPrice) / 100);
      //   if(newDisplayPrice < 0){
      //     newDisplayPrice = newDisplayPrice * -1;
      //   }
      //   this.displayPrice = '+' + newDisplayPrice + ' ' + this.configurator.currencySymbol;
      //   this.priceElement.textContent = '+' + newDisplayPrice + ' ' + this.configurator.currencySymbol;



      if(this.step.isMultipleSelection){
        if(this.price > 0){
          const displayPrice = Math.round(this.price / 100);
          this.priceElement.textContent = '+' + displayPrice + ' ' + this.configurator.currencySymbol;
          return;
        }
      }

      if(this.step.selectedProducts.includes(this)){ 
        this.priceElement.textContent = '';
      } else {
        newDisplayPrice = Math.round((this.step.stepPrice - this.stepPrice) / 100) * -1;
        const shouldDisplayPlusCharacter = newDisplayPrice >= 0;
        this.priceElement.textContent = (shouldDisplayPlusCharacter ? '+' : '') + newDisplayPrice + ' ' + this.configurator.currencySymbol;
      }
    

    }
  
    activate() {
      this.el.classList.add("configurator__step-product--active");
    }
  
    deactivate() {
      this.el.classList.remove("configurator__step-product--active");
    }

    hide() {
        this.hidden = true;
        this.el.classList.add("configurator__step-product--hidden");

        // if the hidden product is the active product, select the first available product
        if(this.step.selectedProducts.includes(this)){
          console.log(this)
            this.step.hideProductAndSelectTheFirstAvailable(this);
        }
    }

    show() {
        this.hidden = false;
        this.el.classList.remove("configurator__step-product--hidden");
    }
  
    isActive() {
      return this.el.classList.contains("configurator__step-product--active");
    }
  }



if (!customElements.get("product-configurator")) {
    customElements.define(
      "product-configurator",
      class ProductConfigurator extends HTMLElement {
        constructor() {
          super();
          this.steps = [];
          this.activeStep = null;
          this.basePrice = 0;
          this.currentPrice = 0;
          this.allExceptions = {};
          this.allProducts = [];
          this.currentVariantId = this.dataset.variantId;
          this.allProductVariantsJSON = JSON.parse(document.querySelector('variant-options script[type="application/json"]').innerHTML);
          this.configuratorContentElement = this.querySelector('.configurator__content');
          this.shippingDate = document.getElementById('shipping_date').textContent;

          this.selectedProductsIds = [];
          console.log(this.shippingDate);
        }
  
        connectedCallback() {
            this.container = this.querySelector('.configurator');
            this.closeButton = this.querySelector('.configurator__header__close');
            this.openButton = document.querySelector('[data-configurator-open]');

            this.configuratorContent = this.querySelector('.configurator__content');
            this.arrowDown = this.querySelector('.configurator__footer-arrow');

            this.stickyHeaderOpenButton = document.querySelector('#pdp-sticky-header .product-form__submit');
            this.stickyHeaderOpenButton.removeAttribute('disabled')

            this.stickyMobileOpenButton = document.querySelector('.wt-product__sticky-buy__button');
            this.stickyHeaderOpenButton.removeAttribute('disabled')

            this.variantOptions = document.querySelector('variant-options');
            this.submitButton = this.querySelector('.configurator__atc-button');

            this.errorsElement = this.querySelector('.configurator__footer-atc-errors');

            this.basePrice = parseFloat(this.dataset.basePrice.replace(',', ''));
            this.currentPrice = this.basePrice;
            this.currencySymbol = this.dataset.currencySymbol;
    

            // bind functions
            this.openButtonClickHandler = this.openButtonClickHandler.bind(this);

            this.addEventListeners();


            subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
                this.updateConfiguratorVariantInfo(e);
            });


          const stepElements = this.querySelectorAll(".configurator__step");
          stepElements.forEach(stepEl => {
              //   create ConfiguratorStep object and add it to the steps array
            const step = new ConfiguratorStep(stepEl, this);
            this.steps.push(step);

            // update arrays of all exceptions and all products
            this.allExceptions = { ...this.allExceptions, ...step.exceptions };
            this.allProducts = [...this.allProducts, ...step.products];
          });

          this.updateSelectedProducts();

          // preselect first step
          // this.activeStep = this.steps[0];
          // this.activeStep.open();

  
          this.updateConfiguratorPrices();
          
          this.updateProductsVisibility();
          this.updateStepVisibility();
        }

        addEventListeners(){
          this.stickyMobileOpenButton.addEventListener('click', this.openButtonClickHandler);
          this.stickyHeaderOpenButton.addEventListener('click', this.openButtonClickHandler);
          this.openButton.addEventListener('click', this.openButtonClickHandler);
          

          this.configuratorContent.addEventListener('scroll', () => {
            this.arrowDown.classList.add('configurator__footer-arrow--hidden');
          });

          this.closeButton.addEventListener('click', () => {
              this.close();
          });

          this.submitButton.addEventListener('click', () => {
              this.submit();
          });
        }

        openButtonClickHandler(e){
          e.preventDefault();
          this.open();
        }

        updateConfiguratorVariantInfo(e){
          // update configurator image
          const featuredImage = this.variantOptions.dataset.featuredImage;
          const image = this.container.querySelector('.configurator__picture img');
          image.src = featuredImage;
          image.srcset = featuredImage;


          // update shipping date
          const shippingDate = e.data?.deliveryDate;
          const shippingDateElement = this.container.querySelector('.configurator__shipping-date');
          if(shippingDate){
            shippingDateElement.textContent = shippingDate;
            this.shippingDate = shippingDate;
          }

          const newVariantId = this.variantOptions.dataset.variantId;
          if(newVariantId !== this.currentVariantId){
            this.currentVariantId = newVariantId;
            const currentVariant = this.allProductVariantsJSON.find(variant => `${variant.id}` === newVariantId);
            
            // adjust configurator price
            if(currentVariant){
              this.currentPrice = this.currentPrice - this.basePrice + currentVariant.price;
              this.basePrice = currentVariant.price;
              this.updateConfiguratorPrices();

              // update configurator dataset
              this.dataset.variantId = newVariantId;
              this.dataset.basePrice = parseFloat(currentVariant.price);
            }
          }
        }

        showLoaderInButton(){
          this.submitButton.setAttribute('disabled', true);
          const loader = this.submitButton.querySelector('.loading-overlay__spinner');
          const text = this.submitButton.querySelector('.configurator__atc-button-text');
          this._originalButtonHTML = text.innerHTML;
          text.classList.add('hidden');
          loader.classList.remove('hidden');
        }

        hideLoaderInButton(){
          const loader = this.submitButton.querySelector('.loading-overlay__spinner');
          const text = this.submitButton.querySelector('.configurator__atc-button-text');
          if (this._originalButtonHTML) text.innerHTML = this._originalButtonHTML;
          text.classList.remove('hidden');
          loader.classList.add('hidden');

          this.submitButton.removeAttribute('disabled');
        }

        updateButtonMessage(message) {
          const text = this.submitButton.querySelector('.configurator__atc-button-text');
          const loader = this.submitButton.querySelector('.loading-overlay__spinner');
          this.submitButton.setAttribute('disabled', true);
          loader.classList.remove('hidden');
          text.classList.remove('hidden');
          text.innerHTML = `<strong>${message}</strong>`;
        }

        async addToCartWithRetry(productForm) {
          const messages = [
            this.getAttribute('data-translation-retry-1') || 'Configuring wheels…',
            this.getAttribute('data-translation-retry-2') || 'Selecting parts…',
            this.getAttribute('data-translation-retry-3') || 'Checking compatibility…',
            this.getAttribute('data-translation-retry-4') || 'Adding to cart…',
          ];
          const retryError = this.getAttribute('data-translation-retry-error') || 'Could not add to cart. Please try again in a moment.';
          const maxAttempts = 8;
          const intervalMs = 2000;

          const form = productForm.querySelector('form');
          const cart = document.querySelector('cart-drawer');

          for (let attempt = 0; attempt < maxAttempts; attempt++) {
            this.updateButtonMessage(messages[Math.min(attempt, messages.length - 1)]);

            try {
              const config = fetchConfig('javascript');
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];

              const formData = new FormData(form);
              formData.append('sections', cart.getSectionsToRender().map((s) => s.id));
              formData.append('sections_url', window.location.pathname);
              config.body = formData;

              const response = await fetch(routes.cart_add_url, config);
              const responseData = await response.json();

              // Success — no error status in response
              if (!responseData.status) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: responseData,
                });
                if (cart) {
                  cart.renderContents(responseData, true);
                  if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
                }
                this.close();
                this.hideLoaderInButton();
                return;
              }

              // 422 = cart service hasn't indexed yet — retry
              if (responseData.status === 422) {
                console.log(`cart/add.js attempt ${attempt + 1}/${maxAttempts}: 422 — ${responseData.description}`);
                if (attempt < maxAttempts - 1) {
                  await new Promise((r) => setTimeout(r, intervalMs));
                  continue;
                }
                // Last 422 attempt — show retry error
                throw new Error(retryError);
              }

              // Any other error (not 422) — stop immediately, show Shopify error
              throw new Error(responseData.description || responseData.message || `Error ${responseData.status}`);

            } catch (err) {
              // Network error or thrown error — stop retrying
              this.errorsElement.textContent = err.message || err;
              this.hideLoaderInButton();
              return;
            }
          }
        }

        async submit(){
          console.log('submit', this.steps);
          this.errorsElement.textContent = '';

          const currentProductVariantOptions= [];
          const variantOptions = [...document.querySelectorAll('variant-options .wt-product__option')];
          variantOptions.forEach(option => {
            const label = option.querySelector('.wt-product__option__title .label').textContent.replace(':', '').trim();
            const value = option.querySelector('.wt-product__option__title .value').textContent.replace(':', '').trim();
            currentProductVariantOptions.push({
              label: label,
              value: value
            });
          });

          
          const createdProduct = {
            product_id: this.dataset.productId,
            variant_id: this.currentVariantId,
            base_price: this.basePrice,
            total_price: this.currentPrice,
            currency_symbol: this.currencySymbol,
            market_handle: this.dataset.marketHandle,
            market_id: this.dataset.marketId,
            steps: [],
            translated_variant_options: currentProductVariantOptions
          }

          this.steps.forEach(step => {
            if(step.showOnlyIfProductIsSelected && !step.isShown) return;

            const stepProducts = {
              step_name: step.stepName,
              is_optional: step.isOptional,
              is_multiple_selection: step.isMultipleSelection,
              selected_products: step.selectedProducts.map(product => {
                return {
                  product_id: product.id,
                  product_title: product.title,
                  product_price: product.price * 100,
                  product_variant_id: product.variantId
                }
              })
            }
            createdProduct.steps.push(stepProducts);
          });

          console.log(createdProduct,
            JSON.stringify(createdProduct)
          );

          this.showLoaderInButton();

          // source product info
          const sourceProductHandle = this.dataset.productHandle;
          const sourceVariantId = this.dataset.variantId;
          const sourceProductId = this.dataset.productId;

          try {
            const response = 
              await fetch('/apps/configurator/create-product', {
              // await fetch('http://127.0.0.1:9000/create-product', {
                method: 'POST',
                body: JSON.stringify(createdProduct),
                headers: {
                  'Content-Type': 'application/json'
                }
              })
            
            const data = await response.json();

            if(!response.ok){
              console.log(response)
              const error = data?.detail || response.statusText || 'Unexpected error while creating product.';
              throw new Error(error);
            }
            
            const productId = data.product_id;
            const variantId = data.variant_id;
            const quantity = 1;

            const cartItems = await fetch(`/cart.js`)
              .then(response => response.json())
              .then(response => {
                return response?.items;
              })
              .catch(error => {
                console.log(error)
              });

            const isProductInCart = cartItems.some(item => String(item?.variant_id) === String(variantId));

            const propertiesArray = data?.steps?.map(step => {
              return {
                [step.step_name]: step.step_products.map(product => product.product_title).join(', ')
              }
            });

            const propertiesObject = Object.assign({}, ...propertiesArray);

             const productForm = this.querySelector('product-form');
             const form = productForm.querySelector('form');

             const formId = productForm.querySelector('input[name="id"]');

             formId.value = variantId;

             const inputPropertiesArray = [];

             propertiesObject['_source-product-handle'] = sourceProductHandle;
             propertiesObject['_source-product-id'] = sourceProductId;
             propertiesObject['_source-variant-id'] = sourceVariantId;

            //  add step products to properties
             for (const [key, value] of Object.entries(propertiesObject)) {
              const inputProperty = document.createElement('input');
              inputProperty.type = 'hidden';
              inputProperty.name = `properties[${key}]`;
              inputProperty.value = value;
              inputPropertiesArray.push(inputProperty);
             }


              // add shipping date to properties
              const shippingPropertyLabel = document.querySelector('.configurator__shipping-date-label').textContent.replace(':', '').trim();
              const shippingDateInput = document.createElement('input');
              if(this.shippingDate && shippingPropertyLabel){
               shippingDateInput.type = 'hidden';
               shippingDateInput.name = 'properties[' + shippingPropertyLabel + ']';
               shippingDateInput.value = this.shippingDate;
               inputPropertiesArray.push(shippingDateInput);
              }

             if(inputPropertiesArray.length > 0){
             for(const inputProperty of inputPropertiesArray){
              form.appendChild(inputProperty);
             }
            }

            if(!isProductInCart){
              if (data.is_new) {
                // New product — Online Store cart service needs time to index.
                // Retry /cart/add.js with animated messages on the button.
                await this.addToCartWithRetry(productForm);
              } else {
                // Existing product — cart/add.js works immediately
                const addToCartButton = productForm.querySelector('.js-add-to-cart');
                addToCartButton.click();
              }
            } else{
              // if product is in cart, close configurator and open cart drawer
              const cartDrawer = document.querySelector('cart-drawer');
              this.close();
              cartDrawer.toggleDrawerClasses();
              this.hideLoaderInButton();
              return;
            }

             setTimeout(() => {
              if(inputPropertiesArray.length > 0){
                for (const inputProperty of inputPropertiesArray) {
                  inputProperty.remove();
                }
              }
             }, 1000);

          } catch (error) {
            console.log(error)
            this.errorsElement.textContent = error;
            this.hideLoaderInButton();
          }
        }

        open(){
          this.errorsElement.textContent = '';
            this.container.classList.remove('configurator--hidden');
            document.body.classList.add('page-overlay-configurator-on');
        }

        close(){
            this.container.classList.add('configurator--hidden');
            document.body.classList.remove('page-overlay-configurator-on');
        }
  
        updateConfiguratorPrices() {
          const priceStr = + Math.round(this.currentPrice / 100) + ' ' + this.currencySymbol;
          const configuratorPrice = this.querySelector('.configurator__header__title__price .price-item');
          const buttonPrice = this.querySelector('.configurator__atc-button .price-item');

          // initPayu(this.currentPrice);

          // const event = new CustomEvent('configuratorPriceUpdate', {
          //   detail: {
          //     price: this.currentPrice
          //   },
          // });

          // document.dispatchEvent(event);
  
          if (configuratorPrice) configuratorPrice.textContent = priceStr;
          if (buttonPrice) buttonPrice.textContent = priceStr;
        }
  
        adjustPrice(delta) {
          this.currentPrice += delta;
          this.updateConfiguratorPrices();
        }

        updateStepVisibility(){
          this.updateSelectedProducts();
          
          this.steps.forEach(step => {
            if(!step.showOnlyIfProductIsSelected) return;

              if(step.showOnlyIfProductIsSelectedIds.some(id => this.selectedProductsIds.includes(id))){
                step.show();
              } else {
                step.hide();
              }
          });
        }

        updateSelectedProducts(){
          this.selectedProductsIds = this.steps.map(step => step.selectedProducts).flat().map(product => product.id);
        }

        updateProductsVisibility(){
            const productsToHide = [];

            // prepare array of products to hide
            this.steps.forEach(step => {
                this.allExceptions[step.stepProductId]?.forEach(exception => {
                    const productToHide = this.allProducts.find(product => product.id === exception);
                    if(productToHide){
                        productsToHide.push(productToHide);
                    }
                });
            });

            // hide or show products
            this.allProducts.forEach(product => {
                if(productsToHide.includes(product)){
                    product.hide();
                } else {
                    product.show();
                }
            });
        }
        
      }
    );
  }

if (!customElements.get("configurator-guide-drawer")) {
    customElements.define(
      "configurator-guide-drawer",
      class ConfiguratorGuideDrawer extends HTMLElement {
        constructor() {
          super();
        }
        
        connectedCallback(){
            this.container = this.querySelector('.configurator-guide');
            this.closeButton = this.querySelector('.configurator-guide__drawer-close');
            this.triggerButtons = document.querySelectorAll('.configurator__step-guide--trigger');
            this.content = this.querySelector('.configurator-guide__drawer-content');
            this.contentTitle = this.container.querySelector('h3');

            this.closeButton.addEventListener('click', () => {
                this.close();
            });

            this.triggerButtons?.forEach(button => {
                button.addEventListener('click', () => {
                    this.open(button);
                });
            });

            this.container.addEventListener('click' , (e) => {
                e.stopPropagation();
                console.log(e.target)
                if(!e.target.closest('.configurator-guide__drawer')){
                    this.close();
                }
            })
        }

        open(button){
            this.container.classList.remove('configurator-guide--hidden');

            const contentId = button.dataset.contentId;
            const content = document.getElementById(contentId);
            const contentTitle = content.dataset.title; 
            
            this.content.innerHTML = content.innerHTML;
            this.contentTitle.innerText = contentTitle;
            console.log(contentTitle, this.contentTitle)
        }

        close(){
            this.container.classList.add('configurator-guide--hidden');
            this.content.innerHTML = '';
        }
      }
    );
  }


// stary kod
// if (!customElements.get("product-configurator")) {
//     customElements.define(
//       "product-configurator",
//       class ProductConfigurator extends HTMLElement {
//         constructor() {
//             super();
//         }
  
//         connectedCallback() {
//             this.node = this;
//             this.steps = this.querySelectorAll('.configurator__step');
//             this.productId = this.dataset.productId;
//             this.basePrice = this.dataset.basePrice;
//             this.currentPrice = this.basePrice;
//             this.currencySymbol = this.dataset.currencySymbol;
            
//             this.steps.forEach(step => {
//                 const stepTop = step.querySelector('.configurator__step-top');
//                 const productSteps = step.querySelectorAll('.configurator__step-product');

//                 stepTop.addEventListener('click', () => {
//                     step.classList.toggle('configurator__step--active');
//                 });

//                 productSteps.forEach(productStep => {
//                     productStep.addEventListener('click', () => {
//                         this.selectStepProduct(productStep);
//                     });
//                 });
               
//             });
//         }

//         selectStepProduct(productStep){

//             const productId = productStep.dataset.productId;
//             const productTitle = productStep.dataset.productTitle;
//             const productPrice = productStep.dataset.productPrice;

//             console.log(productId, productTitle, productPrice);

//             const step = productStep.closest('.configurator__step');
//             const stepTitle = step.querySelector('.configurator__step-title-product');
//             const stepProductId = step.dataset.stepProductId;
//             const stepPrice = step.dataset.stepPrice;
//             const stepIsOptional = step.dataset.isOptional;
//             const stepExceptions = JSON.parse(step.dataset.exceptions) || {};

            
//             const stepsParent = productStep.closest('.configurator__step-bottom');
//             const activeStepProduct = stepsParent.querySelector('.configurator__step-product--active');
//             const activeStepProductPrice = activeStepProduct.dataset.productPrice;

//             // turn off active step
//             if(activeStepProduct){
//                 activeStepProduct.classList.remove('configurator__step-product--active');
//             }

//             // set active step and update title product of step
//             productStep.classList.add('configurator__step-product--active');
//             stepTitle.textContent = productTitle;

//             // check if product is in exceptions TUTAJ SKONCZYKLEM!!!!
//             if(stepExceptions[productId]){
//                 console.log('product is in exceptions');
//                 const stepExceptionsProducts = stepExceptions[productId];
//                 this.hideExceptions(productId, stepExceptionsProducts);
//             }

//             // update step product id
//             step.dataset.stepProductId = productId;

//             // update step price
//             const differenceBetweenActualAndNewPrice = parseFloat(productPrice) - parseFloat(stepPrice);
//             step.dataset.stepPrice = productPrice;

//             // update configurator price
//             this.currentPrice = (parseFloat(this.currentPrice) + differenceBetweenActualAndNewPrice).toFixed(2);
//             this.updateConfiguratorPrices(this.currentPrice);
            
//         }

//         hideExceptions(currentProductId, stepExceptionsProducts){
//             stepExceptionsProducts.forEach(stepExceptionProductId => {
//                 const product = this.node.querySelector(`[data-product-id="${stepExceptionProductId}"]`);

//                 if(product){
                    
//                     // add current product id to hiddenBy array. If it's not empty, the stepExceptionProduct should be hidden
//                     const hiddenByArray = product.dataset.hiddenBy?.split(',') || [];
//                     if(!hiddenByArray.includes(currentProductId)){
//                         hiddenByArray.push(currentProductId);
//                     }

//                     product.dataset.hiddenBy = hiddenByArray.join(',');
                    
//                     product.classList.add('configurator__step-product--hidden');
//                 }
//                 // product.style.display = 'none';
//             });
//         }

//         updateConfiguratorPrices(price){
//             const configuratorPrice = this.querySelector('.configurator__header__title__price .price-item');
//             const buttonPrice = this.querySelector('.configurator__atc-button .price-item');

//             configuratorPrice.textContent = price + this.currencySymbol;
//             buttonPrice.textContent = price + this.currencySymbol;
//         }
  
       
//       },
//     );
//   }
  